export default {
  type: "object",
  properties: {
    id: {
      type: "integer",
      description: "unique identifier",
      example: "1"
    },
    name: {
      type: "string",
      description: "name of user",
      example: "John Doe"
    },
    email: {
      type: "string",
      description: "email of user",
      example: "john@doe.com"
    },
    profile_picture: {
      type: "string",
      description: "url of profile image",
      example: "https://sizeid.com/front/images/profile-male.png"
    },
    gender: {
      $ref: "#/components/schemas/gender"
    }
  }
};
